import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {VTErrorHandler} from './VTErrorHandler';
import {BaseModule} from './base/base.module';
import {Router, RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RecaptchaV3Module
} from 'ng-recaptcha';
import * as Sentry from '@sentry/angular-ivy';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    BaseModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    RecaptchaFormsModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: VTErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6Le5EF0sAAAAAMUlalqX4FQuPQpk5_UNc5Ia0HPV' } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6Le5EF0sAAAAAMUlalqX4FQuPQpk5_UNc5Ia0HPV'
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
